export const USER_KEY = 'user';
export const TOKEN_KEY = 'token';
export const ACCOUNT_KEY = 'accounts'
export const GROUP_KEY = 'groups'
export const CUR_ACCOUNT_ID_KEY = 'currentAccountId';
// export const DATE_RANGE_KEY = 'dateRange';
export const ANALYSIS_TYPE = 'analysisType';
export const ALL_ACCOUNT_KEY = 'allAccounts';

export const mutations = {
    SET_TOKEN(state, token) {
        state.token = token;
        localStorage.setItem(TOKEN_KEY, token);
    },
    SET_USER(state, user) {
        state.user = user;
        localStorage.setItem(USER_KEY, JSON.stringify(user));
    },
    REMOVE_USER(state) {
        state.user = [];
        localStorage.removeItem(USER_KEY)
    },
    SET_ACCOUNTS(state, accounts){
        state.accounts = accounts;
        localStorage.setItem(ACCOUNT_KEY, JSON.stringify(accounts));
    },
    SET_GROUPS(state, groups){
        state.groups = groups;
        localStorage.setItem(GROUP_KEY, JSON.stringify(groups));
    },
    SET_ALL_ACCOUNTS(state, allAccounts){
        state.allAccounts = allAccounts;
        localStorage.setItem(ALL_ACCOUNT_KEY, JSON.stringify(allAccounts));
    },
    SET_CUR_ACCOUNT_ID(state, accountId) {
        state.curAccountId = accountId;
        localStorage.setItem(CUR_ACCOUNT_ID_KEY, JSON.stringify(accountId));
    },
    SET_DATE_RANGE(state, dateRange){
        state.dateRange = dateRange;
        // localStorage.setItem(DATE_RANGE_KEY, JSON.stringify(dateRange));
    },
    SET_ANALYSIS_TYPE(state, analysisType){
        state.analysisType = analysisType;
        localStorage.setItem(ANALYSIS_TYPE, analysisType);
    },
    SET_SHOW_FOOTER(state, showFooter){
        state.showFooter = showFooter;
    },
    SET_All_VARIETIES(state, varieties){
        state.allVarieties = varieties;
    },
    SET_All_VARIETY_NAMES(state, varietyNames){
        state.allVarietyNames = varietyNames;
    },
    CLEAR_ALL(state){

        state.token = null;
        state.curAccountId = [];
        state.accounts = [];
        state.allAccounts = [];
        state.groups = [];
        state.allVarieties = [];
        state.analysisType = 'single';
        state.user = [];

        localStorage.clear()
    }
};
